import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  BaseFormItem,
  BaseInput,
  BaseTextContent,
  BaseTextTitle,
  BaseForm,
  BaseImage
} from 'xrk-components';
import { IndividualInfoDetailData } from '../../data-source/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'operator',
  props: {
    "modelValue": {},
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

const formData = _useModel<IndividualInfoDetailData>(__props, "modelValue");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(BaseTextTitle), null, {
      default: _withCtx(() => [
        _createTextVNode("经营者信息")
      ]),
      _: 1
    }),
    _createVNode(_unref(BaseTextContent), null, {
      default: _withCtx(() => [
        _createVNode(_unref(BaseForm), {
          "label-position": "top",
          disabled: "",
          model: formData.value,
          "column-count": 4
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseFormItem), {
              label: "姓名",
              prop: "operator",
              rules: [
          {
            required: true,
            trigger: 'change',
            message: '请选择'
          }
        ]
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  style: {"width":"100%"},
                  type: "text",
                  placeholder: "请输入",
                  modelValue: formData.value.operator,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.operator) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "联系电话",
              prop: "phone",
              rules: [
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  style: {"width":"100%"},
                  type: "text",
                  placeholder: "请输入",
                  modelValue: formData.value.phone,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.phone) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "身份证号",
              prop: "idcard",
              rules: [
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  style: {"width":"100%"},
                  type: "text",
                  placeholder: "请输入",
                  clearable: "",
                  modelValue: formData.value.idcard,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.idcard) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              style: {"grid-column-start":"1","grid-column-end":"3"},
              label: "身份证国徽面",
              prop: "cardIdFront",
              rules: [
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseImage), {
                  style: {"width":"100%","height":"200px"},
                  fit: "contain",
                  src: formData.value.cardIdFront,
                  "preview-src-list": [formData.value.cardIdFront]
                }, null, 8, ["src", "preview-src-list"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              style: {"grid-column-start":"3","grid-column-end":"5"},
              label: "身份证人像面",
              prop: "cardIdBack",
              rules: [
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseImage), {
                  style: {"width":"100%","height":"200px"},
                  fit: "contain",
                  src: formData.value.cardIdBack,
                  "preview-src-list": [formData.value.cardIdBack]
                }, null, 8, ["src", "preview-src-list"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    })
  ], 64))
}
}

})